const blocks = [
    {
        coords: [
            [[0, 1], [1, 1], [2, 1], [3, 1]],
            [[1, 0], [1, 1], [1, 2], [1, 3]],
            [[0, 1], [1, 1], [2, 1], [3, 1]],
            [[1, 0], [1, 1], [1, 2], [1, 3]]
        ],
        shape: 'I'
    }, {
        coords: [
            [[0, 1], [1, 1], [2, 1], [2, 2]],
            [[1, 0], [1, 1], [1, 2], [2, 0]],
            [[0, 1], [0, 2], [1, 2], [2, 2]],
            [[1, 2], [2, 0], [2, 1], [2, 2]]
        ],
        shape: 'J'
    }, {
        coords: [
            [[0, 1], [0, 2], [1, 1], [2, 1]],
            [[1, 0], [1, 1], [1, 2], [2, 2]],
            [[0, 2], [1, 2], [2, 1], [2, 2]],
            [[1, 0], [2, 0], [2, 1], [2, 2]]
        ],
        shape: 'L'
    }, {
        coords: [
            [[1, 1], [1, 2], [2, 1], [2, 2]],
            [[1, 1], [1, 2], [2, 1], [2, 2]],
            [[1, 1], [1, 2], [2, 1], [2, 2]],
            [[1, 1], [1, 2], [2, 1], [2, 2]]
        ],
        shape: 'O'
    }, {
        coords: [
            [[0, 2], [1, 1], [1, 2], [2, 1]],
            [[1, 0], [1, 1], [2, 1], [2, 2]],
            [[0, 2], [1, 1], [1, 2], [2, 1]],
            [[1, 0], [1, 1], [2, 1], [2, 2]]
        ],
        shape: 'S'
    }, {
        coords: [
            [[0, 1], [1, 1], [1, 2], [2, 1]],
            [[1, 0], [1, 1], [1, 2], [2, 1]],
            [[0, 2], [1, 1], [1, 2], [2, 2]],
            [[1, 1], [2, 0], [2, 1], [2, 2]]
        ],
        shape: 'T'
    }, {
        coords: [
            [[0, 1], [1, 1], [1, 2], [2, 2]],
            [[1, 1], [1, 2], [2, 0], [2, 1]],
            [[0, 1], [1, 1], [1, 2], [2, 2]],
            [[1, 1], [1, 2], [2, 0], [2, 1]]
        ],
        shape: 'Z'
    }
]

const random = () => Math.floor(Math.random() * blocks.length)

export const chooseBlock = (n: number | null = null) => blocks[n ?? random()]
